import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import './OffMarketBuyAndSellDetailsModal.scss';
import '../MessagesModal/MessagesModal.scss';
import './BuyingTemplateIndicator.scss';

type Props = {
  estimation: any;
  estimationStatus: 'idle' | 'queued' | 'in_progress' | 'completed' | 'failed' | 'error';
  isPolling: boolean;
  estimationError: string;
  formData: {
    description: string;
    size: string;
    rooms: string;
    floor: string;
    hasElevator: boolean;
    hasBalcony: boolean;
    renovationStatus: string;
  };
  askingPrice: string;
  setAskingPrice: (askingPrice: string) => void;
  setForceShowPreFields: (forceShowPreFields: boolean) => void;
  setIsPreEstimationModalOpen: (isPreEstimationModalOpen: boolean) => void;
  setIsPriceReportOpen: (isPriceReportOpen: boolean) => void;
  isLoggedIn?: boolean;
  setLoginModalVisible?: (isVisible: boolean) => void;
  addressObject?: any;
  onMissingAddress?: () => void;
  showAddressValidation?: boolean;
  isBuildingPage?: boolean;
};

const PriceEstimationBanner: React.FC<Props> = ({
  estimation,
  estimationStatus,
  isPolling,
  estimationError,
  formData,
  isLoggedIn,
  askingPrice,
  setAskingPrice,
  setForceShowPreFields,
  setIsPreEstimationModalOpen,
  setIsPriceReportOpen,
  setLoginModalVisible,
  addressObject,
  onMissingAddress,
  showAddressValidation,
  isBuildingPage,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`off-market-modal__price-section ${isBuildingPage ? 'off-market-modal__price-section--building-page' : ''}`}>
      {/*       <div className="off-market-modal__form-field">
        <label htmlFor="property-price">
          <Trans i18nKey="building.offMarket.modal.askingPrice" />
        </label>
        <input
          id="property-price"
          type="number"
          className="off-market-modal__input"
          value={askingPrice}
          onChange={(e) => setAskingPrice(e.target.value)}
          placeholder={t('building.offMarket.modal.pricePlaceholder')}
          min="0"
        />
      </div> */}

      {/* Price Estimation Status */}
      {((estimationStatus === 'idle' || estimationStatus === 'completed') && !isPolling && !estimationError) && (
        <div className={`off-market-modal__estimation-banner off-market-modal__estimation-banner--info off-market-modal__estimation-banner--clickable ${isBuildingPage ? 'off-market-modal__estimation-banner--building-page' : ''} ${estimationStatus === 'completed' && isBuildingPage ? 'off-market-modal__estimation-banner--completed-building-page' : ''}`}
          onClick={() => {
            // If not logged in, open signup/login modal instead of starting estimation
/*             if (!isLoggedIn) {
              if (setLoginModalVisible) {
                setLoginModalVisible(true);
              }
              return;
            } */
            // Check if address is selected (only when onMissingAddress callback is provided)
            if (onMissingAddress && !addressObject) {
              onMissingAddress();
              return;
            }
            // If fields are missing, show the guiding fields and keep them visible
            const shouldForceShow = (formData.size.trim() === '' || formData.rooms.trim() === '');
            setForceShowPreFields(shouldForceShow);
            setIsPreEstimationModalOpen(true);
          }}
        >
          <div className="off-market-modal__price-estimation-icon-container">
            <img
              className={`off-market-modal__price-estimation-icon ${isBuildingPage ? 'off-market-modal__price-estimation-icon--building-page' : ''}`}
              src="/assets/jaakko_head.png" height="25px" alt="Jaakko AI" />
            <svg className="off-market-modal__ai-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 490 490" width="25" height="25" preserveAspectRatio="xMidYMid meet">
              <g>
                <path fill="#F0CD00" d="M490,245c0,135.31-109.69,245-245,245c-71.33,0-135.54-30.48-180.31-79.13   c-11.76-12.77-22.17-26.8-31.03-41.85C12.27,332.64,0,290.25,0,245C0,109.69,109.69,0,245,0c45.26,0,87.65,12.27,124.02,33.67   c15.05,8.85,29.07,19.26,41.84,31.03C459.51,109.45,490,173.67,490,245z" />
                <path fill="#FFDE50" d="M490,245c0,132.26-104.79,240.04-235.88,244.83C123.03,485.04,18.24,377.26,18.24,245   S123.03,4.96,254.12,0.17C385.21,4.96,490,112.74,490,245z" />
                <path fill="#FFEA94" d="M410.86,64.7L64.69,410.87c-11.76-12.77-22.17-26.8-31.03-41.85L369.02,33.67   C384.07,42.52,398.09,52.93,410.86,64.7z" />
                <path fill="#FFEA94" d="M473.1,155.43L155.42,473.11c-22.49-8.84-43.36-20.91-62.03-35.64L437.47,93.39   C452.2,112.06,464.27,132.93,473.1,155.43z" />
                <path fill="#FAA300" d="M435.38,245c0,105.14-85.24,190.38-190.38,190.38c-36.62,0-70.82-10.34-99.85-28.26   c-12.65-7.8-24.31-17.05-34.77-27.51c-7.69-7.68-14.73-16.03-21.02-24.94c-8.66-12.27-15.91-25.61-21.5-39.78   c-8.28-20.95-12.94-43.73-13.22-67.55c-0.02-0.78-0.02-1.56-0.02-2.34c0-105.14,85.23-190.38,190.38-190.38   c0.78,0,1.57,0,2.35,0.02c23.82,0.28,46.59,4.95,67.54,13.22c14.17,5.6,27.51,12.84,39.78,21.5c8.91,6.3,17.25,13.33,24.94,21.02   c10.46,10.45,19.71,22.12,27.51,34.77C425.04,174.18,435.38,208.38,435.38,245z" />
                <path fill="#FFBD00" d="M379.61,110.38L110.38,379.61c-7.69-7.68-14.73-16.03-21.02-24.94   c-8.66-12.27-15.91-25.61-21.5-39.78c-8.28-20.95-12.94-43.73-13.22-67.55c-0.02-0.78-0.02-1.56-0.02-2.34   c0-105.14,85.23-190.38,190.38-190.38c0.78,0,1.57,0,2.35,0.02c23.82,0.28,46.59,4.95,67.54,13.22   c14.17,5.6,27.51,12.84,39.78,21.5C363.58,95.66,371.92,102.69,379.61,110.38z" />
                <path fill="#F68E00" d="M435.375,245c0,105.14-85.24,190.38-190.38,190.38c-3.61,0-7.19-0.1-10.75-0.3   c100.14-5.57,179.62-88.55,179.62-190.08s-79.48-184.51-179.62-190.08c3.56-0.2,7.14-0.3,10.75-0.3   C350.135,54.62,435.375,139.86,435.375,245z" />
              </g>
              <path fill="#F68E00" d="M324.578,292.066c-9.624-5.424-21.82-2.019-27.243,7.604c-14.865,26.376-39.298,42.123-65.359,42.123  c-25.685,0-48.553-14.989-63.053-38.173h55.084c11.046,0,20-8.954,20-20s-8.954-20-20-20H154.16  c-0.966-6.028-1.478-12.251-1.478-18.619s0.512-12.591,1.478-18.619h69.847c11.046,0,20-8.954,20-20s-8.954-20-20-20h-55.084  c14.5-23.184,37.368-38.173,63.053-38.173c26.061,0,50.494,15.747,65.359,42.123c5.423,9.622,17.621,13.028,27.243,7.604  c9.623-5.423,13.027-17.62,7.604-27.243c-22.05-39.125-59.511-62.483-100.206-62.483c-32.485,0-62.831,14.65-85.447,41.251  c-9.32,10.962-16.845,23.434-22.417,36.922H98.676c-11.046,0-20,8.954-20,20s8.954,20,20,20h15.103  c-0.722,6.124-1.097,12.339-1.097,18.619s0.375,12.496,1.097,18.619H98.676c-11.046,0-20,8.954-20,20s8.954,20,20,20h25.435  c5.572,13.488,13.097,25.959,22.417,36.922c22.616,26.601,52.962,41.251,85.447,41.251c40.695,0,78.156-23.358,100.206-62.483  C337.605,309.686,334.201,297.489,324.578,292.066z" />
              <path fill="#FFEA94" d="M349.58,292.066c-9.624-5.424-21.82-2.019-27.243,7.604c-14.865,26.376-39.298,42.123-65.359,42.123  c-25.685,0-48.553-14.989-63.053-38.173h55.084c11.046,0,20-8.954,20-20s-8.954-20-20-20h-69.847  c-0.966-6.028-1.478-12.251-1.478-18.619s0.512-12.591,1.478-18.619h69.847c11.046,0,20-8.954,20-20s-8.954-20-20-20h-55.084  c14.5-23.184,37.368-38.173,63.053-38.173c26.061,0,50.494,15.747,65.359,42.123c5.423,9.622,17.621,13.028,27.243,7.604  c9.623-5.423,13.027-17.62,7.604-27.243c-22.05-39.125-59.511-62.483-100.206-62.483c-32.485,0-62.831,14.65-85.447,41.251  c-9.32,10.962-16.845,23.434-22.417,36.922h-25.435c-11.046,0-20,8.954-20,20s8.954,20,20,20h15.103  c-0.722,6.124-1.097,12.339-1.097,18.619s0.375,12.496,1.097,18.619h-15.103c-11.046,0-20,8.954-20,20s8.954,20,20,20h25.435  c5.572,13.488,13.097,25.959,22.417,36.922c22.616,26.601,52.962,41.251,85.447,41.251c40.695,0,78.156-23.358,100.206-62.483  C362.607,309.686,359.202,297.489,349.58,292.066z" />
            </svg>
          </div>
          <span>
            {isBuildingPage ? t('building.offMarket.modal.startPriceEstimationBuildingPage') : t('building.offMarket.modal.startPriceEstimation')}
          </span>
          <svg className={`off-market-modal__arrow-icon ${isBuildingPage ? 'off-market-modal__arrow-icon--building-page' : ''}`} width="16" height="16" viewBox="0 0 24 24" fill="none" style={{ marginLeft: 'auto' }}>
            <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      )}

      {(estimationStatus === 'queued' || estimationStatus === 'in_progress' || isPolling) && (
        <div className={`off-market-modal__estimation-banner off-market-modal__estimation-banner--loading ${isBuildingPage ? 'off-market-modal__estimation-banner--building-page' : ''}`}>
          <div className="off-market-modal__spinner-small"></div>
          <span>{t('building.offMarket.modal.estimatingPrice')}</span>
          <small>{t('building.offMarket.modal.emailWhenReady')}</small>
        </div>
      )}

      {estimationStatus === 'completed' && estimation && (
        <div className={`off-market-modal__estimation-banner off-market-modal__estimation-banner--success ${isBuildingPage ? 'off-market-modal__estimation-banner--building-page' : ''} ${estimationStatus === 'completed' && isBuildingPage ? 'off-market-modal__estimation-banner--success--building-page' : ''}`}>
          <svg className="off-market-modal__check-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span>
            {t('building.offMarket.modal.estimationReady')}{/* :
                          {estimation.result.price_range.min && estimation.result.price_range.max ?
                            ` €${estimation.result.price_range.min.toLocaleString()} - €${estimation.result.price_range.max.toLocaleString()}` :
                            estimation.result.estimated_price ?
                              ` €${estimation.result.estimated_price.toLocaleString()}` :
                              ' Available'} */}
          </span>
          <button
            className="off-market-modal__view-report-btn"
            onClick={() => setIsPriceReportOpen(true)}
          >
            {t('building.offMarket.modal.viewFullReport')}
          </button>
        </div>
      )}

      {estimationStatus === 'failed' && (
        <div className={`off-market-modal__estimation-banner off-market-modal__estimation-banner--error ${isBuildingPage ? 'off-market-modal__estimation-banner--building-page' : ''}`}>
          <span>{t('building.offMarket.modal.estimationFailed')}</span>
        </div>
      )}

      {estimationStatus === 'error' && estimationError && (
        <div className={`off-market-modal__estimation-banner off-market-modal__estimation-banner--error ${isBuildingPage ? 'off-market-modal__estimation-banner--building-page' : ''}`}>
          <span>{t(`building.offMarket.modal.estimationError.${estimationError}`)}</span>
        </div>
      )}
      {showAddressValidation && (
        <div className={`off-market-modal__address-validation ${isBuildingPage ? 'off-market-modal__address-validation--building-page' : ''}`}>
          {/*           <svg className="off-market-modal__address-validation-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg> */}
          <span>{t('building.offMarket.modal.selectBuildingFirst')}</span>
        </div>
      )}
    </div>
  );
};

export default PriceEstimationBanner;